<template>
  <div class="keyword-column-settings">
    <IconicButton
      :text="$t('ADVERTISEMENT.BIDS.CHANGE_COLUMN')"
      icon="view_column"
      @click="openModal('showColumnSettings')"
    />
    <KeywordColumnSettingsModal
      v-model="showColumnSettings"
      :visible-columns="visibleColumns"
      :hidden-columns="hiddenColumns"
      :locked-columns="lockedColumns"
      @update:visible-columns="updateVisibleColumns"
      @update:hidden-columns="updateHiddenColumns"
    />
  </div>
</template>

<script>
import KeywordColumnSettingsModal from './KeywordColumnSettingsModal';
import IconicButton from '@@/advertisement/common/IconicButton';

import modal from '@/mixins/modal';

export default {
  name: 'KeywordColumnSettings',
  components: {
    KeywordColumnSettingsModal,
    IconicButton,
  },
  mixins: [modal],
  props: {
    visibleColumns: {
      type: Array,
      required: true,
    },
    lockedColumns: {
      type: Array,
      default: () => [],
    },
    hiddenColumns: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      showColumnSettings: false,
    };
  },
  methods: {
    updateVisibleColumns(visibleColumns) {
      this.$emit('update:visible-columns', visibleColumns);
    },
    updateHiddenColumns(hiddenColumns) {
      this.$emit('update:hidden-columns', hiddenColumns);
    },
  },
};
</script>

<style lang="scss">
.keyword-column-settings {
  display: flex;
  justify-content: flex-end;
}
</style>
